import { useEffect, type EffectCallback } from "react";

/**
 * `useEffect` que roda apenas na montagem, por design (ex.: restaurar estado
 * de um cookie, medir o DOM uma vez). O nome deixa a intenção explícita no
 * call site, em vez de espalhar `eslint-disable-next-line react-hooks/exhaustive-deps`
 * pelos componentes.
 */
export function useEffectOnce(effect: EffectCallback): void {
    // O único eslint-disable de exhaustive-deps do projeto vive aqui, de
    // propósito: é a razão de este hook existir (ver docstring).
    // eslint-disable-next-line react-hooks/exhaustive-deps -- só na montagem, por design
    useEffect(effect, []);
}
